// Primary Fonts
import SofiaProSemiBoldWoff from './fonts/sofia-pro/SofiaPro-SemiBold.woff';
import SofiaProSemiBoldWoff2 from './fonts/sofia-pro/SofiaPro-SemiBold.woff2';
import SofiaProRegularWoff from './fonts/sofia-pro/SofiaPro-Regular.woff';
import SofiaProRegularWoff2 from './fonts/sofia-pro/SofiaPro-Regular.woff2';
import { Typography } from '../brands';

const typography: Typography = {
  primary: {
    fontFamily: 'Sofia Pro',
    fontStyle: 'normal',
    sources: {
      bold: [SofiaProSemiBoldWoff, SofiaProSemiBoldWoff2],
      regular: [SofiaProRegularWoff, SofiaProRegularWoff2],
    },
  },
  secondary: {
    fontFamily: 'Sofia Pro',
    fontStyle: 'normal',
    sources: {
      bold: [SofiaProSemiBoldWoff, SofiaProSemiBoldWoff2],
      regular: [SofiaProRegularWoff, SofiaProRegularWoff2],
    },
  },
};
export default typography;
